import { Box, Button, IconButton } from "@mui/material";
import React from "react";
import AppDropDown from "../common/filter/AppDropDown";
import FormSmallTextField from "../common/form/FormTextField";
import { FilterValue } from "../../../models/Filters/FilterValue";
import { ProductOption } from "../../../models/Products/ProductOption";
import { ProductVariant } from "../../../models/Products/ProductVariant";
import { Delete } from "@mui/icons-material";

type AddProductVariantValuesProps = {
  productId: number;
  options: ProductOption[];
  onDoneClick: (values: ProductVariant[]) => void;
};

const AddProductVariantValues = ({
  productId,
  options,
  onDoneClick,
}: AddProductVariantValuesProps) => {
  const [selectedOption, setSelectedOption] = React.useState<string>("-1");
  const [selectedOptionValues, setSelectedOptionValues] = React.useState<
    ProductVariant[]
  >([]);

  const handleDelete = (index: number) => {
    const list = selectedOptionValues.filter(
      (value, itemIndex) => index !== itemIndex
    );

    setSelectedOptionValues(list);
  };

  return (
    <Box>
      <Box sx={{ marginTop: 2.8,marginBottom:4, width: "100%" }}>
        <AppDropDown
          title=""
          isMultiSelect={false}
          list={options.map((option) => {
            let filter = {
              id: String(option.id),
              value: option.name,
            } as FilterValue;
            return filter;
          })}
          height="36px"
          listHeight="30px"
          fontSize="14px"
          value={selectedOption}
          onSingleSelectionChange={(id) => {
            setSelectedOption(id);
            setSelectedOptionValues([
              ...selectedOptionValues,
              {
                product_id: productId,
                options_id: Number(id),
                title: "",
              },
            ]);
          }}
        />
      </Box>
      {selectedOptionValues.map((optionValue, index) => (
        <Box sx={{ display: "flex", gap: 2 }} key={index}>
          <Box sx={{ width: 1 / 5 }}>
            <FormSmallTextField
              id={String(index)}
              label="Title"
              required
              variant="outlined"
              color="secondary"
              type="name"
              fontSize="14px"
              value={optionValue.title || ""}
              onChange={(id, value) => {
                const intID = Number(id);
                const lastItem = selectedOptionValues[intID];
                const updatedItem = {
                  ...lastItem,
                  title: value,
                } as ProductVariant;
                let newList = [...selectedOptionValues];
                newList[intID] = updatedItem;
                if (intID === selectedOptionValues.length - 1) {
                  setSelectedOptionValues([
                    ...newList,
                    {
                      product_id: productId,
                      options_id: updatedItem.options_id,
                      title: "",
                    },
                  ]);
                } else {
                  setSelectedOptionValues(newList);
                }
              }}
            />
          </Box>
          <Box sx={{ width: 1 / 5 }}>
            <FormSmallTextField
              id={String(index)}
              label="Value"
              required
              variant="outlined"
              color="secondary"
              type="name"
              fontSize="14px"
              value={optionValue.value || ""}
              onChange={(id, value) => {
                const intID = Number(id);
                const lastItem = selectedOptionValues[intID];
                const updatedItem = {
                  ...lastItem,
                  value: value,
                } as ProductVariant;
                let newList = [...selectedOptionValues];
                newList[intID] = updatedItem;
                if (intID === selectedOptionValues.length - 1) {
                  setSelectedOptionValues([
                    ...newList,
                    {
                      product_id: productId,
                      options_id: updatedItem.options_id,
                      title: "",
                    },
                  ]);
                } else {
                  setSelectedOptionValues(newList);
                }
              }}
            />
          </Box>
          <Box sx={{ width: 1 / 5 }}>
            <FormSmallTextField
              id={String(index)}
              label="Cost Price"
              variant="outlined"
              color="secondary"
              type="name"
              fontSize="14px"
              value={
                optionValue.cost_price ? String(optionValue.cost_price) : ""
              }
              onChange={(id, value) => {
                const intID = Number(id);
                const lastItem = selectedOptionValues[intID];
                const updatedItem = {
                  ...lastItem,
                  cost_price: value ? Number(value) : 0,
                } as ProductVariant;
                let newList = [...selectedOptionValues];
                newList[intID] = updatedItem;
                if (intID === selectedOptionValues.length - 1) {
                  setSelectedOptionValues([
                    ...newList,
                    {
                      product_id: productId,
                      options_id: updatedItem.options_id,
                      title: "",
                    },
                  ]);
                } else {
                  setSelectedOptionValues(newList);
                }
              }}
            />
          </Box>
          <Box sx={{ width: 1 / 5 }}>
            <FormSmallTextField
              id={String(index)}
              label="Selling Price"
              variant="outlined"
              color="secondary"
              type="name"
              fontSize="14px"
              value={
                optionValue.selling_price
                  ? String(optionValue.selling_price)
                  : ""
              }
              onChange={(id, value) => {
                const intID = Number(id);
                const lastItem = selectedOptionValues[intID];
                const updatedItem = {
                  ...lastItem,
                  selling_price: value ? Number(value) : 0,
                } as ProductVariant;
                let newList = [...selectedOptionValues];
                newList[intID] = updatedItem;
                if (intID === selectedOptionValues.length - 1) {
                  setSelectedOptionValues([
                    ...newList,
                    {
                      product_id: productId,
                      options_id: updatedItem.options_id,
                      title: "",
                    },
                  ]);
                } else {
                  setSelectedOptionValues(newList);
                }
              }}
            />
          </Box>
          <Box sx={{ width: 1 / 5 }}>
            <FormSmallTextField
              id={String(index)}
              label="SKU"
              variant="outlined"
              color="secondary"
              type="name"
              fontSize="14px"
              value={optionValue.sku}
              onChange={(id, value) => {
                const intID = Number(id);
                const lastItem = selectedOptionValues[intID];
                const updatedItem = {
                  ...lastItem,
                  sku: value,
                } as ProductVariant;
                let newList = [...selectedOptionValues];
                newList[intID] = updatedItem;
                if (intID === selectedOptionValues.length - 1) {
                  setSelectedOptionValues([
                    ...newList,
                    {
                      product_id: productId,
                      options_id: updatedItem.options_id,
                      title: "",
                    },
                  ]);
                } else {
                  setSelectedOptionValues(newList);
                }
              }}
            />
          </Box>
          <Box>
            <IconButton color="default" onClick={() => handleDelete(index)}>
              <Delete />
            </IconButton>
          </Box>
        </Box>
      ))}
      {selectedOptionValues.length !== 0 && (
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box>
            <Button
              onClick={() => {
                setSelectedOption("");
                setSelectedOptionValues([]);
              }}
            >
              CLEAR
            </Button>
          </Box>
          <Box>
            <Button
              variant="outlined"
              onClick={() => {
                const addedVariants = selectedOptionValues.filter(
                  (option) => option.title && option.title !== ""
                );

                setSelectedOption("");
                setSelectedOptionValues([]);

                onDoneClick(addedVariants);
              }}
            >
              DONE
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AddProductVariantValues;
